import React from 'react';
import { Box } from '@mui/material';

interface VacancyGroupTabContentProps {
  children?: React.ReactNode;
}

const VacancyGroupTabContent: React.FC<VacancyGroupTabContentProps> = ({ children }) => (
  <Box role="tabpanel" sx={{ position: 'relative', width: '100%', minHeight: '200px' }}>
    {children}
  </Box>
);

export default VacancyGroupTabContent;
